export const ACCOUNT_PLAN_LABEL = {
  BASIC: 'Basic',
  NOT_PAID: 'Not paid',
  TESTER: 'Tester',
  TRAINER: 'Trainer',
  PREMIUM_BY_ADMIN: 'Premium · by admin',
  PREMIUM_FREE_TRIAL: 'Premium · free trial',
  PREMIUM_PAID: 'Premium · paid',
  PREMIUM: 'Premium',
};

export const isPremiumPlan = (plan) =>
  plan === 'PREMIUM' ||
  plan === 'PREMIUM_BY_ADMIN' ||
  plan === 'PREMIUM_FREE_TRIAL' ||
  plan === 'PREMIUM_PAID' ||
  plan === 'TESTER' ||
  plan === 'TRAINER';

export const getAccountPlanLabel = (plan) => ACCOUNT_PLAN_LABEL[plan] ?? plan ?? '—';

export const getAccountPlanBadgeClass = (plan) => {
  if (plan === 'TESTER') return 'planTester';
  if (plan === 'TRAINER') return 'planTrainer';
  if (isPremiumPlan(plan)) return 'planB';
  if (plan === 'NOT_PAID') return 'planC';
  return 'planA';
};

export const getAccountPlanCssModifier = (plan) => {
  if (plan === 'TESTER') return 'tester';
  if (plan === 'TRAINER') return 'trainer';
  if (plan === 'NOT_PAID') return 'not-paid';
  if (isPremiumPlan(plan)) return 'premium';
  return 'basic';
};
